import { isObject } from './is-object';

export function toCamelCasedKeys(object: any): any {
  if (object === null || object === undefined) {
    return object;
  }
  return Object.keys(object).reduce((acc, key) => {
    let value = object[key];

    if (isObject(value)) {
      value = toCamelCasedKeys(value);
    } else if (Array.isArray(value)) {
      value = value.map((item) => isObject(item) ? toCamelCasedKeys(item) : item);
    }

    const camelCasedKey = toCamelCase(key);
    acc[camelCasedKey] = value;

    return acc;
  }, {});
}

export function toCamelCase(value: string): string {
  return value.replace(/(_[a-z0-9])/g, ($1) => {
    // $1 e.g. _a
    return $1[1].toUpperCase();
  });
}
